export type TopazSetupRequest = PaymentMechanism & { traceId: string }

export enum ResultCode {
  // See https://apglobal.atlassian.net/wiki/spaces/PAYL/pages/21399554/Result+Codes
  OK = 0,
  TRANSIENT_GATEWAY_ERROR = 1,
  INVALID_DETAILS = 21,
  DUPLICATE_CARD = 22,
  EXCEEDED_MAX_ATTEMPTS_ENTERING_DETAILS = 23,
  INSUFFICIENT_FUNDS = 41,
  INVALID_SHIPPING_DETAILS = 51,
  INVALID_STATE = 98,
  OTHER_ERROR = 99,
  USER_CHALLENGE_FAILED = 101,
  UNACCEPTABLE_CARD = 61,
  INVALID_REQUEST_PARAMETERS = 2,
  VELOCITY_RULE_BREACH = 3,
  FRAUD_RULE_BREACH = 4,
  REQUIRE_THREE_DS_AUTHENTICATION = 100,
  THREE_DS_CHALLENGE_PENDING = 102,
}

export enum BlockedReasonCode {
  ISSUER_RESTRICTED = 'BE-2-ISSUER-RESTRICTED-BLOCK',
  GENERIC = 'BE-1-GEN-BLOCK',
}

export interface TopazResult {
  resultCode: ResultCode
  maskedPan?: string
  blockedReasonCode?: string
}

export type PaymentMechanism = NewCard | SavedCard | ApplePayToken
// This is the Topaz request model for a new card
export interface NewCard {
  cardHolderName: string // eg 'Joe Blogs'
  cardNumber: string // eg '4111111111111111'
  cardSecurityCode: string // eg '123'
  cardExpiryMonth: string // eg '04'
  cardExpiryYear: string // eg '23'
  address?: {
    street1?: string
    street2?: string // should be undefined not null when N/A
    city?: string
    state?: string // should be undefined not null when N/A
    postcode?: string
    country?: string
  }
}

export interface SavedCard {
  token: string
}

export interface ApplePayToken {
  paymentSourceId: string
}
